import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Alert
} from '@mui/material';
import {
  HourglassEmpty as HourglassIcon,
  CheckCircle as CheckIcon
} from '@mui/icons-material';

function JoinRequestPendingPage() {
  const location = useLocation();
  const navigate = useNavigate();
  
  const organizationName = location.state?.organizationName || 'the organization';

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper sx={{ p: 4 }} elevation={2}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <HourglassIcon sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom>
            Join Request Submitted
          </Typography>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Your request to join <strong>{organizationName}</strong> is pending approval
          </Typography>
        </Box>

        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body1">
            <strong>What happens next?</strong>
          </Typography>
          <Typography variant="body2" component="div" sx={{ mt: 1 }}>
            1. Organization admins will review your join request<br />
            2. You'll receive notification once your request is approved<br />
            3. After approval, you can log in and access the meeting room system
          </Typography>
        </Alert>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
          <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center' }}>
            You can close this page. We'll notify you when your request is processed.
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button
              variant="outlined"
              onClick={() => navigate('/login')}
            >
              Go to Login
            </Button>
            
            <Button
              variant="text"
              onClick={() => navigate('/')}
            >
              Go to Home
            </Button>
          </Box>
        </Box>

        <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <CheckIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'middle' }} />
            <strong>Your account has been created successfully!</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            You can already log in, but you'll need to wait for organization approval to access the meeting rooms.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default JoinRequestPendingPage; 